import React from 'react';
import PropTypes from 'prop-types';
import { Text, } from 'react-native-web';
import { Button, } from '@payit/cool-web-ui-library';
import HtmlUtils from '../../../modules/HtmlUtils';
import './ConversationViewer.css';

class ConversationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibility: 'hidden',
    };
  }

  show() {
    this.setState({ visibility: 'shown', });
  }

  hide() {
    this.setState({ visibility: 'hidden', });
  }

  copy(text) {
    navigator.clipboard.writeText(HtmlUtils.toHtmlText(text));
  }

  render() {
    const { task, input, } = this.props;
    const jsonData = JSON.stringify(task.state, null, 3);
    const { visibility, } = this.state;
    return (
      <div
        className="convo-block"
        role="button"
        tabIndex={0}
      >
        <h4 className="task-header">{task.taskId}
          <Button onClick={() => this.hide()}>Hide</Button>
          <Button onClick={() => this.show()}>Show</Button>
          <Button onClick={() => this.copy(jsonData)}>Copy</Button>
        </h4>
        <h4 className="task-header">{input !== undefined && input.label !== undefined ? <span>{input.label}</span> : null}</h4>
        <div className={visibility}>
          <Text style={{
            fontFamily: 'monospace', display: 'inline-block', textAlign: 'left', backgroundColor: '#DCDCDC',
          }}
          >
            {jsonData}
          </Text>
        </div>
      </div>

    );
  }
}

ConversationModal.defaultProps = {
  input: undefined,
};

ConversationModal.propTypes = {
  task: PropTypes.instanceOf(Object).isRequired,
  input: PropTypes.instanceOf(Object),
};

export default ConversationModal;
